<div class="container">
    <div class="zoom-container">
        <div id="meetingSDKElement">
            <!-- Zoom Meeting SDK Rendered Here -->
            </div>
    </div>
</div>

<div *ngIf="zoomError === 'eventNotFound'" class="error-bg" role="alert">
    <div class="error-container">
        <span class="error-title">Este evento no existe</span>
        <span class="error-subtitle">No pudimos encontrar el evento o tu acceso a él.</span>
        <span class="error-hint">Por favor revisa que la URL sea correcta o pide ayuda a soporte.</span>
        <button type="button" class="error-button" (click)="retry()">Reintentar</button>
    </div>
</div>

<div *ngIf="zoomError === 'connection'" class="error-bg" role="alert">
    <div class="error-container">
        <span class="error-title">Hubo un error al conectarse al evento</span>
        <span class="error-subtitle">Esto puede deberse a alguno de los siguientes motivos:</span>
        <ul class="error-reasons">
            <li>Tu red (corporativa, VPN o firewall) está bloqueando la conexión con Zoom.</li>
            <li>Tu conexión a internet es inestable o muy lenta.</li>
            <li>Una extensión del navegador (por ejemplo, un bloqueador de anuncios) impide que Zoom cargue.</li>
            <li>Tu navegador está desactualizado.</li>
            <li>El evento aún no ha comenzado o ya terminó.</li>
        </ul>
        <span class="error-hint">Intenta con otra red (por ejemplo, datos móviles) o pide a tu área de TI que permita los dominios zoom.us y *.zoom.us.</span>
        <button type="button" class="error-button" (click)="retry()">Reintentar</button>
    </div>
</div>
